import { alpha, Box, Container, Stack, Typography, useTheme } from "@mui/material";
import CohortCarouselSection from "../../../component/courseDetailSection/CohortCarouselSection";
import DescriptionSection from "../../../component/courseDetailSection/DescriptionSection";
import FactsSection from "../../../component/courseDetailSection/FactsSection";
import HeroSection from "../../../component/courseDetailSection/HeroSection";
import SharingSection from "../../../component/courseDetailSection/SharingSection";
import { useCourseDetailsPageData } from "../../../hook/useCourseDetailsPageData";
import { courseName } from "./const/course";
import FullTimeCourseExtraSections from "./component/FullTimeCourseExtraSections";
import CourseTimeline_FullTime from "./component/CourseTimeline_FullTime";
import pageMapData from "./const/pagemap.json";
import type { CoursePageMap } from "../../../type/course";

const pageMap = pageMapData as CoursePageMap;

export default function CourseDetailsPage_FullTime() {
  const theme = useTheme();
  const data = useCourseDetailsPageData({ courseName, pageMap });

  return (
    <Box
      sx={{
        minHeight: 1,
        bgcolor: "background.default",
        backgroundImage: `
          radial-gradient(ellipse 58% 22% at 22% 5%, ${alpha(theme.palette.info.main, 0.1)} 0%, ${alpha(theme.palette.info.main, 0)} 76%),
          radial-gradient(ellipse 50% 18% at 12% 47%, ${alpha(theme.palette.info.dark, 0.09)} 0%, ${alpha(theme.palette.info.dark, 0)} 74%),
          radial-gradient(ellipse 46% 18% at 82% 82%, ${alpha(theme.palette.info.main, 0.055)} 0%, ${alpha(theme.palette.info.main, 0)} 72%),
          radial-gradient(ellipse 56% 24% at 95% 100%, ${alpha(theme.palette.info.light, 0.16)} 0%, ${alpha(theme.palette.info.main, 0.06)} 42%, ${alpha(theme.palette.info.main, 0)} 76%),
          linear-gradient(180deg, ${alpha(theme.palette.primary.main, 0.72)} 0%, ${theme.palette.background.default} 18%, ${
          theme.palette.background.default
        } 74%, ${
          theme.palette.background.default
        } 100%)
        `,
        backgroundSize: "100% 100%, 100% 100%, 100% 100%, 100% 100%, 100% 100%",
        backgroundRepeat: "no-repeat",
      }}
    >
      <Stack spacing={0}>
        <Container maxWidth="lg" sx={{ px: { xs: 3, md: 4 } }}>
          <HeroSection data={data} />
        </Container>

        <Container maxWidth="lg" sx={{ px: { xs: 3, md: 4 } }}>
          <DescriptionSection data={data} />
        </Container>

        <Stack component="section" spacing={3} sx={{ py: { xs: 4, md: 6 }, justifyContent: "center", alignItems: "center", display: "flex" }}>
          <Container maxWidth="lg" sx={{ px: { xs: 3, md: 4 } }}>
            <Stack spacing={1.5} sx={{ maxWidth: 720 }}>
              <Typography variant="h3" color="primary.contrastText">
                課程模組
              </Typography>
              <Box sx={{ width: { xs: 56, md: 72 }, height: 3, bgcolor: alpha(theme.palette.info.main, 0.42) }} />
            </Stack>
          </Container>

          <Container
            maxWidth="lg"
            sx={{
              px: { xs: 3, md: 4 },
              "--courseTimelineItemMaxWidth": "560px",
              justifyContent: "center",
              alignItems: "center",
              display: "flex",
            }}
          >
            <CourseTimeline_FullTime />
          </Container>
        </Stack>

        <Container maxWidth="lg" sx={{ px: { xs: 3, md: 4 } }}>
          <FullTimeCourseExtraSections />
          <CohortCarouselSection data={data} />
          <SharingSection data={data} />
          <FactsSection data={data} />
        </Container>
      </Stack>
    </Box>
  );
}




